import { createRef, InputHTMLAttributes, useEffect } from "react";

type IndeterminateCheckBoxProps = Pick<InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
  checked?: boolean | "indeterminate";
};

export const IndeterminateCheckBox = ({ checked, onChange }: IndeterminateCheckBoxProps) => {
  const ref = createRef<HTMLInputElement>();
  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = checked === "indeterminate" ? true : false;
    }
  }, [ref, checked]);

  return <input ref={ref} onChange={onChange} checked={!!checked} type="checkbox" className="mr-2" />;
};
